import type { CookieCategoryValue } from ".";
import { callbacks } from "./onCookieConsent";
import syncCookieConsent from "./syncCookieConsent";

interface OneTrustGroupsUpdatedEventType extends Event {
	detail: (CookieCategoryValue)[];
}

const initCookieConsent = () => {
	// fired on load and when any explicit consent action is taken
	window.addEventListener('OneTrustGroupsUpdated', (event: OneTrustGroupsUpdatedEventType) => {
		callbacks.forEach((cb) => cb(event.detail));
	});

	// fired only when explicit consent action is taken
	window.addEventListener('OTConsentApplied', () => {
		syncCookieConsent();
	});
};

export default initCookieConsent;
